<template>
  <div class="bridge-signing-view container fluid">
    <v-card>
      <FinancialProductExposeView />
    </v-card>
  </div>
</template>

<script>
import FinancialProductExposeView from './FinancialProductExposeView.vue';

export default {
  name: 'FinancialProductExpose',
  components: {
    FinancialProductExposeView,
  },
  data() {
    return {};
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$store.dispatch('fetchFpExposeTypes');
      this.$store.dispatch('fetchFpExposeAll');
    },
  },
};
</script>

<style lang="scss">
.bridge-signing-view {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/financialProducts/FinancialProductExpose.vue